import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export interface ConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  content?: string;
  message?: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
  confirmDisabled?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title,
  content,
  message,
  severity = 'warning',
  confirmDisabled = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
    onCancel();
  };

  const dialogContent = content || message;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description" color={severity}>
          {dialogContent}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Abbrechen
        </Button>
        <Button 
          onClick={handleConfirm} 
          color="primary" 
          variant="contained" 
          autoFocus
          disabled={confirmDisabled}
        >
          Bestätigen
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 